import { useRef } from 'react';
import { TextInputField } from 'modules/templateEditor/common/components';
import { PushContentDefinition } from 'modules/graphql/types';
import { FormField } from 'ui/formField';
import { getIsEditMode, constructFieldErrors } from '../../common/utils';
import { constructErrorInlineText } from '../../common/ErrorInlineText';
import { FieldNames } from '../../common/types';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { getRestrictionText } from '../utils';
import { useErrorValidationContext } from '../../context/ErrorValidationContext';
import { StyledTooltip } from '../styles';

export const Title = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const titleRef = useRef<HTMLInputElement | null>(null);

  const mediumDataValue =
    !isEditMode && pushData.isSilentPush
      ? SETTINGS_DISPLAY_CONTENT.deliverSilently.silenced
      : pushData.title || '';

  const { hasError: hasTitleError, hasWarning: hasTitleWarning } = constructFieldErrors({
    contentErrors: localeContentErrors,
    contentWarnings: localeContentWarnings,
    fieldName: FieldNames.TITLE,
  });

  const titleErrorText = constructErrorInlineText({
    condition: isEditModeVisible,
    hasError: hasTitleError,
    hasWarning: hasTitleWarning,
  });

  return (
    <FormField
      isDisabled={pushData.isSilentPush}
      isHorizontalLayout
      hasError={hasTitleError}
      hasWarning={hasTitleWarning}
      errorText={titleErrorText}
      labelText={SETTINGS_DISPLAY_CONTENT.title.labelText}
      restrictionText={getRestrictionText(pushData.title, isEditModeVisible)}
    >
      <StyledTooltip
        isEnabled={pushData.isSilentPush && isEditMode}
        tooltipContent={SETTINGS_DISPLAY_CONTENT.deliverSilently.restriction}
      >
        <TextInputField
          isDisabled={pushData.isSilentPush}
          hasError={hasTitleError}
          hasWarning={hasTitleWarning}
          mediumRef={titleRef}
          mediumDataKey={'title'}
          mediumDataValue={mediumDataValue}
          changeHandler={(title) => setCurrentMediumField('title', title)}
          showSnippet
        />
      </StyledTooltip>
    </FormField>
  );
};
